import { ErrorBoundary } from '@sentry/react';
import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

import { TableSkeleton } from '@eluve/blocks';
import {
  Content,
  Header,
  Heading,
  SidebarTrigger,
  Stack,
} from '@eluve/components';
import { useCaptureEventOnMount } from '@eluve/posthog-react';

import { PatientsList } from './PatientsList';

export const PatientsListPage: React.FC = () => {
  useCaptureEventOnMount('page_view_patients_list');
  return (
    <>
      <Helmet>
        <title>Patients | Eluve</title>
      </Helmet>
      <Header>
        <SidebarTrigger />
        <div className="my-2 py-2">
          <Heading>Patients</Heading>
        </div>
      </Header>
      <Content padded>
        <Suspense fallback={<TableSkeleton rowCount={20} />}>
          <ErrorBoundary
            fallback={
              <Stack gap={2}>
                <p>Failed to load patient data.</p>
                <TableSkeleton rowCount={5} />
              </Stack>
            }
          >
            <PatientsList />
          </ErrorBoundary>
        </Suspense>
      </Content>
    </>
  );
};
